module.exports = "pegasus_template/assets/facebook.png";